import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { MetaTags } from "../interface/metaTags.interface";

const MetaTagsSEO = ({ metaTags,title }: { metaTags: MetaTags[],title:string }) => {
 
  return (
    <HelmetProvider>
      <Helmet>
      <title>{title}</title>
        {metaTags.map((tag, index) =>
          tag.property ? (
            <meta key={index} property={tag.property} content={tag.property === "og:url" ? `${window.location.origin}/${tag.content}`  : tag.content}/>
          ) : (
            <meta key={index} name={tag.name} content={tag.content} />
          )
          
        )}
      </Helmet>
    </HelmetProvider>
  );
};

export default MetaTagsSEO;
